const router = [
    {
        path: '/resources/list',
        component: () => import( '../views/Resources/ResourcesList.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
      {
        path: '/resources/detail',
        component: () => import( '../views/Resources/Detail.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
      {
        path: '/resources/salesList',
        component: () => import( '../views/Resources/SalesList.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
      {
        path: '/resources/release',
        component: () => import( '../views/Resources/Release.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
      {
        path: '/resources/form',
        component: () => import( '../views/Resources/Form.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
]
export default router
